import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCol,
  IonRow,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonGrid,
  useIonViewDidEnter,
} from "@ionic/react";
import { useParams } from "react-router";
import ExploreContainer from "../components/ExploreContainer";
import {
  Descriptions,
  Row,
  Col,
  notification,
  message,
  Table,
  Tag,
  Modal,
} from "antd";
import { Card } from "antd";
import { Switch } from "antd";
import { Input } from "antd";
import moment from "moment";
import { PageHeader } from "antd";
import "./Page2.css";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { DatePicker, Space, Button } from "antd";

import React, { useState } from "react";
import { Link } from "react-router-dom";

import axios from "axios";
import { DataGrid, GridCellParams, GridSortDirection, GridToolbar } from "@mui/x-data-grid";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { createStyles, makeStyles, Theme } from "@mui/material/styles";

const dateFormat = "YYYY/MM/DD";
const { Column, ColumnGroup } = Table;

const Amenities: React.FC = (props: any) => {

  const [enteredstatus, setEnteredStatus] = useState("");
  const [currentAmenity, setCurrentAmenity] = useState({});
  const [isModalStatusVisible, setIsStatusModalVisible] = useState(false);
  

  const handleStatusOk = () => {
    setIsStatusModalVisible(false);
    UpdateAmenity();
  };

  const showStatusModal = () => {
    setIsStatusModalVisible(true);
  };

  const statusChangeHandler = (event: any,amenity:any) => {
    setEnteredStatus(event.target.value);
    setCurrentAmenity(amenity);
    showStatusModal();
  };

  const handleBackDropClose = () => {
    setOpen(false);
  };

  const [open, setOpen] = useState(true);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      backdrop: {
        background: "black",
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
      },
    })
  );

  const classes = useStyles();

  const { name } = useParams<{ name: string }>();

  const columns = [
    { field: "id", headerName: "ID", width: 150 },
    { field: "Name", headerName: "NAME", width: 300 },
    { field: "Room", headerName: "ROOM", width: 300 },
    { field: "Property", headerName: "PROPERTY", width: 300 },
    {
      field: "Status",
      headerName: "STATUS",
      width: 190,
      renderCell: (params: GridCellParams) => (
        <strong>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            style={{ width: "180px" }}
            onChange={(e) => statusChangeHandler(e, params.row)}
            value={params.value}
          >
            <MenuItem value={"Enabled"}>Enabled</MenuItem>
            <MenuItem value={"Disabled"}>Disabled</MenuItem>
          </Select>
        </strong>
      ),
    },
  ];

  const [data1, SetData] = useState([]);

  useIonViewDidEnter(() => {
    axios
      .get("https://dev.northroom.co.za/api/bizprop/ammenities/all")
      .then(function (response) {
        // handle success
        console.log(response.data);
        SetData(response.data);
        handleBackDropClose();
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
      });
  });

  async function UpdateAmenity() {
    /* @ts-ignore */
    let tempAmenity = currentAmenity;
    /* @ts-ignore */
    tempAmenity.Status = enteredstatus;
  
    console.log(tempAmenity);

    try {
      axios({
        method: "post",
        url: "https://dev.northroom.co.za/api/bizprop/properties/save/ammenity",
        data: tempAmenity,
      })
        .then(function (response) {
          //handle success
          console.log(response);
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });
    } catch (error) {
      console.error(error.response.data);
    }
  }

  return (
    <IonPage>
      <Backdrop
        className={classes.backdrop}
        open={open}
        transitionDuration={1500}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <IonHeader>
      < Modal
          
          visible={isModalStatusVisible}
          onOk={handleStatusOk}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <Space direction="vertical">
            {/* @ts-ignore */}
            <p>{enteredstatus} {currentAmenity.Name}</p>
          </Space>
        </Modal>
        
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonRow>
            <PageHeader
              className="site-page-header"
              onBack={() => {
                props.history.goBack();
              }}
              title="Amenities"
            />
          </IonRow>
        </IonToolbar>
       
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Space direction="vertical">
          <IonGrid>
            <IonRow>
              <IonCol size="11" style={{ paddingLeft: "2vw", paddingRight: "5vw" }}>
                <IonCard>
                  <IonCardHeader>
                    <Link to="/NewAmenities">
                      <Button type="primary">Add Amenity</Button>
                    </Link>
                  </IonCardHeader>

                  <IonCardContent>
                    <div
                      style={{
                        height: 400,
                        width: "80vw",
                        paddingRight: "7.5vw",
                      }}
                    >
                      <DataGrid
                        rows={data1}
                        columns={columns}
                        components={{
                          Toolbar: GridToolbar,
                        }}
                        sortModel={[
                          {
                            field: 'Name',
                            sort: 'asc' as GridSortDirection,
                          },
                        ]}
                      />
                    </div>
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        </Space>
      </IonContent>
    </IonPage>
  );
};

export default Amenities;
